import { Header } from "@/components/header";
import { RankingView } from "@/components/ranking-view";

export default function AdminRanking() {
  return (
    <div className="flex flex-col">
      <Header title="Classement" />
      <RankingView testID="admin-ranking-screen" />
    </div>
  );
}
